import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { CreditTerm } from "@/app/services/generated/credittermService";
import { creditTermService } from "@/app/services/generated/credittermService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasCreditTermsCache {
  creditTerms: CreditTermsCache;
}

// Singleton cache store
const creditTermsCacheStore = new EntityCacheStore<CreditTerm>(
  EnumCacheEntityType.creditTerm,
  async () => creditTermService.getAllCreditTerms()
);

// Ephemeral reader
export default class CreditTermsCache extends EntityWithGuidKeyCache<CreditTerm> {
  constructor() {
    super(creditTermsCacheStore, (x) => x.id);
  }
}
